import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { NavItem } from '@libs/models/nav-item.interface';
import { IContact } from '@libs/models/models';
import { EnvironmentType } from '@libs/models/environment.type';
import { environment } from '@libs/environment';
import { CapacitorUtils } from '@libs/shared/capacitor/capacitor-utils';

@Component({
  selector: 'app-header-mobile-navigation',
  templateUrl: `./templates/${environment.name}/page.html`,
  styleUrls: [`./templates/${environment.name}/style.sass`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderMobileNavigationComponent {
  @Input()
  public items: NavItem[] = [];

  @Input()
  public active: boolean;

  @Input()
  public isMenu: boolean;

  @Input()
  public phones: IContact[] = [];

  @Input()
  public env: EnvironmentType;

  @Input()
  public isWebSite: boolean = false;

  @Input()
  public isLogged: boolean;

  @Input()
  public langPath: string = '';

  @Output()
  public readonly logoutEvent: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public readonly removeAccountEvent: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public readonly itemClickEvent: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public readonly hamburgerEvent: EventEmitter<void> = new EventEmitter<void>();

  public isCalling: boolean = false;
  public isApp: boolean = CapacitorUtils.isApp;

  constructor(private cd: ChangeDetectorRef) {}

  public getFullPath(route: string): string {
    return this.langPath + route;
  }

  public callEvent(): void {
    if (this.isCalling) return;
    this.isCalling = true;
    window.location.href = this.phones[0].contact;
    setTimeout(() => {
      this.isCalling = false;
      this.cd.detectChanges();
    }, 1000);
  }
}
